import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import qs from 'qs'

import { updatePageTitle } from '../actions/pageInfo'

export const useTitleChange = title => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updatePageTitle(title))

    return () => dispatch(updatePageTitle(null))
  }, [title])
}

export const useQuery = () => {
  return qs.parse(useLocation().search, { ignoreQueryPrefix: true })
}

export const useClearTitle = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updatePageTitle(null))
  }, [])
}

export const useInitDispatch = (dataLoadFn, deps = []) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(dataLoadFn)
  }, deps)
}

/**
 * recommended method for storing and accessing state/props from previous render cycle
 * @param value
 * @returns {undefined}
 */
export const usePrevious = value => {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  })

  return ref.current
}
